var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-section',{staticClass:"form-section mt-12 pt-12 border-t-2",scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h2',[_vm._v("Bank Details")]),_vm._v(" "),_c('div',{staticClass:"italic text-sm text-grey-700"},[_c('p',[_vm._v("Please provide us with your bank details that you wish for the funds to be released.")]),_vm._v(" "),_c('p',[_vm._v("You payment reference will be: "),_c('strong',[_vm._v(_vm._s(_vm.project.ref))])]),_vm._v(" "),_c('p',{staticClass:"text-negative-500"},[_c('icon',{staticClass:"w-4 h-4 icons-negative mr-1 align-text-bottom",attrs:{"icon":"important"}}),_vm._v(" "),_c('strong',[_vm._v("All these fields are required.")])],1)])]},proxy:true}])},[_vm._v(" "),_c('div',{staticClass:"-mx-6 flex flex-wrap -mb-8"},[_c('input-default',{attrs:{"error":_vm.errors.account_name,"input":{
        'key':'account_name',
        'type':'text',
        'label':'Account Name',
        'instructions':null,
        'attributes':{
          'placeholder':'Account Name',
          'default':null,
          'prepend':null,
          'append':null,
          'locked':_vm.loading,
          'required':true
        },
        'wrapper':{
          'width':'full'
        },
        'validation':{
          'min':false,
          'max':false,
          'limit': false
        }
      },"application-value":_vm.details.account_name},on:{"update:input":_vm.updateDetails}}),_vm._v(" "),_c('input-default',{attrs:{"error":_vm.errors.sort_code,"input":{
        'key':'sort_code',
        'type':'text',
        'label':'Sort Code',
        'instructions':null,
        'attributes':{
          'placeholder':'xxxxxx',
          'default':null,
          'prepend':null,
          'append':null,
          'locked':_vm.loading,
          'required':true
        },
        'wrapper':{
          'width':'1/3'
        },
        'validation':{
          'min':false,
          'max':false,
          'limit': 6
        }
      },"application-value":_vm.details.sort_code},on:{"update:input":_vm.updateDetails}}),_vm._v(" "),_c('input-default',{attrs:{"error":_vm.errors.account_number,"input":{
        'key':'account_number',
        'type':'text',
        'label':'Account Number',
        'instructions':null,
        'attributes':{
          'placeholder':'xxxxxxxx',
          'default':null,
          'prepend':null,
          'append':null,
          'locked':_vm.loading,
          'required':true
        },
        'wrapper':{
          'width':'2/3'
        },
        'validation':{
          'min':false,
          'max':false,
          'limit': 8
        }
      },"application-value":_vm.details.account_number},on:{"update:input":_vm.updateDetails}}),_vm._v(" "),_c('input-default',{attrs:{"error":_vm.errors.bank_name,"input":{
        'key':'bank_name',
        'type':'text',
        'label':'Bank Name',
        'instructions':null,
        'attributes':{
          'placeholder':'e.g. HSBC',
          'default':null,
          'prepend':null,
          'append':null,
          'locked':_vm.loading,
          'required':true
        },
        'wrapper':{
          'width':'full'
        },
        'validation':{
          'min':false,
          'max':false,
          'limit': false
        }
      },"application-value":_vm.details.bank_name},on:{"update:input":_vm.updateDetails}}),_vm._v(" "),_c('input-default',{attrs:{"error":_vm.errors.bank_address,"input":{
        'key':'bank_address',
        'type':'text',
        'label':'Bank Address',
        'instructions':null,
        'attributes':{
          'placeholder': null,
          'default':null,
          'prepend':null,
          'append':null,
          'locked':_vm.loading,
          'required':true
        },
        'wrapper':{
          'width':'full'
        },
        'validation':{
          'min':false,
          'max':false,
          'limit': false
        }
      },"application-value":_vm.details.bank_address},on:{"update:input":_vm.updateDetails}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }